import styled from "styled-components";

export const ProjectsContainer = styled.div`
	margin: 20px 0;
	line-height: 1.6;
`;

export const ProjectList = styled.div`
	margin-top: 16px;
`;

export const Project = styled.div`
	margin: 16px 0;
	padding: 12px;
	border: 1px solid #00ff00;
	border-radius: 4px;
`;

export const ProjectNumber = styled.span`
	color: #00ff00;
	font-weight: bold;
	margin-right: 8px;
`;

export const ProjectTitle = styled.div`
	color: #00ff00;
	font-weight: bold;
	font-size: 18px;
	margin-bottom: 8px;
`;

export const ProjectDesc = styled.div`
	color: #00cc00;
	margin-bottom: 8px;
`;

export const ProjectTech = styled.div`
	color: #006600;
	font-size: 14px;
`;

export const Instruction = styled.div`
	margin-top: 20px;
	color: #ffff00;
	font-style: italic;
`;
